import {
  Component,
  EventEmitter,
  Input,
  NgModule,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import moment from 'moment';
import { HelpersService } from '../../../../../services/helpers.service';
import { PartnerService } from '../../../../../services/partner.service';
import { PaymentService } from '../../../../../services/payment.service';

@Component({
  selector: 'app-working-schedule',
  templateUrl: './working-schedule.component.html',
  styleUrls: ['./working-schedule.component.scss'],
})
export class WorkingScheduleComponent implements OnInit {
  @Input() users;
  @Output() getUsers = new EventEmitter();

  public technicians = [];
  public lockDates = true;
  public techniciansAllowed = 0;
  public allocatedTechnicians = 0;
  public loadingPaymentStatus = true;

  public fromDate = moment().startOf('month').format('YYYY-MM-DD');
  public toDate = moment().endOf('month').format('YYYY-MM-DD');

  constructor(
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    private paymentService: PaymentService,
  ) {
    this.loadingPaymentStatus = true;
    this.paymentService
      .getPaymentStatus(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.techniciansAllowed = res.techniciansAllowed;
          console.log(res);
          this.loadingPaymentStatus = false;
        },
        (err) => {
          this.loadingPaymentStatus = false;
        },
      );
  }

  ngOnInit() {
    //Filter the users for users that have a technicianID and a technician/fitter role --- These APIs really need a rework
    this.technicians = this.users.filter((x) => {
      return (
        x.TechnicianID > 0 &&
        x.UserRoles.filter((y) => {
          return (
            y.PartnerID === this.helpersService.getPartnerId() &&
            (y.RoleID === 1 || y.RoleID === 4)
          );
        }).length > 0
      );
    });
    this.allocatedTechnicians = this.technicians.length;
  }

  ngOnChanges() {
    this.technicians = this.users.filter((x) => {
      return (
        x.TechnicianID > 0 &&
        x.UserRoles.filter((y) => {
          return (
            y.PartnerID === this.helpersService.getPartnerId() &&
            (y.RoleID === 1 || y.RoleID === 4)
          );
        }).length > 0
      );
    });
    this.allocatedTechnicians = this.technicians.length;
  }

  updateDate(event) {
    if (this.lockDates) {
      this.fromDate = moment(event.fromDate)
        .startOf('month')
        .format('YYYY-MM-DD');
      this.toDate = moment(event.toDate).endOf('month').format('YYYY-MM-DD');
    }
  }
}
